export function hoverTextColorClasses(textColor, disabled = false) {
  if (disabled) return ''

  return {
    // Indigo
    'text-indigo-600': 'hover:text-indigo-500 dark:hover:text-indigo-200',

    // Gray
    'text-gray-500': 'hover:text-gray-700 dark:hover:text-gray-100',

    // Green
    'text-green-700': 'hover:text-green-600 dark:hover:text-green-100',

    // Blue
    'text-blue-700': 'hover:text-blue-600 dark:hover:text-blue-100',

    // Red
    'text-red-700': 'hover:text-red-600 dark:hover:text-red-100',

    // Yellow
    'text-yellow-700': 'hover:text-yellow-600 dark:hover:text-yellow-100',
  }[textColor]
}
